export const DEFAULT_ADHERENCE_THRESHOLDS = {
  deviceOnHours: 16,
  deviceWornHours: 16,
  extremeNegativeMaxHours: 2
}

export function buildAdherenceReview(thresholds) {
  const deviceWornHours = Number(thresholds.deviceWornHours)
  return {
    adherence_review: {
      thresholds: {
        // Synced to worn hours: worn is the binding adherence constraint
        deviceOnHours: deviceWornHours,
        deviceWornHours,
        extremeNegativeMaxHours: Number(thresholds.extremeNegativeMaxHours)
      }
    }
  }
}

export function hydrateAdherenceReview(processingResults = {}) {
  const review = processingResults.adherence_review
  const defaults = { ...DEFAULT_ADHERENCE_THRESHOLDS }

  if (review?.thresholds && typeof review.thresholds === 'object') {
    const deviceWornHours = Number(review.thresholds.deviceWornHours ?? defaults.deviceWornHours)
    return {
      deviceOnHours: deviceWornHours,
      deviceWornHours,
      extremeNegativeMaxHours: Number(review.thresholds.extremeNegativeMaxHours ?? defaults.extremeNegativeMaxHours)
    }
  }

  return defaults
}
